// 处理admin 数据逻辑方法


// 按值依次查找childen
export function findSupLink (data, pathName, key = 'key') {
  var fun = function (i, n, k) {
    if (i && i.length > 0) {
      for (let v of i) {
        let flag = false
                  
        flag = v.key === n ? v[k] : false
        if (flag) {
          return `${flag}`
        }
        else {
          if (v.children && v.children.length > 0) {
            let re = fun(v.children, n, k)
            if (re) {
              return v[k] + ',' + re
            }
          }
        }
      }
    }
  }

  let ret = fun(data, pathName, key)
  if (!ret) {
    return []
  }
  return ret.split(',')
}
